import { Directive, Input, TemplateRef } from '@angular/core';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { Placement } from '@popperjs/core';


@Directive({
  selector: '[muiPopover]',
  exportAs: 'muiPopover'
})
export class MuiPopoverDirective extends NgbPopover {

  placement: Placement = 'auto';

  @Input()
  set muiPopover(value: string | TemplateRef<any> | null | undefined) {
    this.ngbPopover = value;
  }

  /**
   *
   * @param {string | 'autoClosing'} triggers should be a string evaluated to events used by ng-bootstrap
   *   https://ng-bootstrap.github.io/#/components/popover/examples#triggers if 'sticky' is supplied as triggers, it sets the
   *   triggers to click and the autoClose property to 'outside' this results in a sticky popover, which can be closed by
   *   clicking outside the element
   */
  @Input()
  set muiPopoverTriggers(triggers: string | 'sticky') {
    if (triggers == 'sticky') {
      this.triggers = 'click';
      this.autoClose = 'outside';
    } else {
      this.triggers = triggers;
      this.autoClose = false;
    }
  }

  @Input()
  set muiPopoverPlacement(placement: Placement) {
    this.placement = placement;
  }
}
